<template>
  <div id="contact" class="form-container">

    <div id="err-lead" class="form-container__error">
      <p>入力内容が正しくありません。<br />お確かめのうえ再度入力してください。</p>
    </div>

    <h3 class="p-contact__title">CONTACT FORM</h3>
    <div id="c-form" class="form"><form name="frm" method="POST" action="/contact//">
      <ul>
        <li>
          <span>Name</span>
          <input id="usr-name" type="text" name="name" value="">
          <p id="err-name" class="error err-name">エラーが発生しています。</p>
        </li>
        <li>
          <span>E-mail address</span>
          <input id="usr-mail1" type="text" name="mail1" value="">
          <p id="err-mail1" class="error err-mail1">エラーが発生しています。</p>
        </li>
        <li>
          <span>E-mail address again</span>
          <input id="usr-mail2" type="text" name="mail2" value="">
          <p id="err-mail2" class="error err-mail2">エラーが発生しています。</p>
        </li>
        <li>
          <span>Message</span>
          <textarea id="usr-message" name="message"></textarea>
          <p id="err-message" class="error err-message">エラーが発生しています。</p>
        </li>
      </ul>

      <!--
      <div class="article">
        <p>上記の入力内容で間違いがなければ送信ボタンを押してください。</p>
      </div>
      -->

      <div class="send">
        <a class="c-btnSend" href="#" @click.prevent="confirm">CONFIRM</a>
      </div>
    </form></div>

    <div id="c-conf" class="form form--confirm" style="display: none;">
      <ul>
        <li>
          <span>Name</span>
          <p id="conf-name">ゴエム ゴエム</p>
        </li>
        <li>
          <span>E-mail address</span>
          <p id="conf-mail1">yamanaka@homunculus.jp</p>
        </li>
        <li>
          <span>Message</span>
          <pre id="conf-message"></pre>
        </li>
      </ul>

      <!--
      <div class="article">
        <p>上記の入力内容で間違いがなければ送信ボタンを押してください。</p>
      </div>
      -->

      <ul class="send">
        <a class="c-btnSend" href="#" @click.prevent="back">BACK</a>
        <a class="c-btnSend" href="#" @click.prevent="submit">SUBMIT</a>
      </ul>
    </div>

    <div id="c-complete" class="complete" style="display: none;">
      <p>お問い合わせありがとうございました。<br>数日内にご返信致しますので、<br class="is-sp">今しばらくお待ちください。</p>
    </div>
  </div>
</template>

<script>
  import { breakpoint, assets_path } from '@/_constant/variables';
  import AnyStore from '@/_modules/utils/AnyStore';
  import store from '@/_modules/utils/stores';
  import axios from 'axios';
  import validator from 'validator';
  import xss from 'xss';
  import {gsap, Cubic} from 'gsap/all';
  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    data() {
      return {
        assets_path: assets_path,
        isLoaded: false,
        vNames: {
          "name": {
            name: "お名前",
            rule: [
              "required",
              "max:150"
            ],
            type: "text",
          },
          "mail1": {
            name: "メールアドレス",
            rule: [
              "required",
              "email",
              "max:250"
            ],
            type: "text",
          },
          "mail2": {
            name: "メールアドレス（確認）",
            rule: [
              "required",
              "email",
              "max:250",
              "equal:mail1"
            ],
            type: "text",
          },
          "message": {
            name: "メッセージ",
            rule: [
              "required"
            ],
            type: "textarea",
          },
        },
        isConfirm: false,
        isError: false,
        isValidated: false,
        errMsgs: {},
        formResult: {},
        formValue: {},
      }
    },
    store,
    computed: {
    },
    mounted() {
      requestAnimationFrame(this.init);
    },
    methods: {
      init() {

      },
      confirm(e) {
        e.preventDefault();
        if (this.isConfirm) return;
        this.isConfirm = true;

        // エラーメッセージを消す
        this.hideErrors();

        // 入力チェック
        for (let name in this.vNames) {
          if (typeof(name) !== 'string') continue;
          let value = '';
          let result = '';
          const el = document.getElementById(`usr-${name}`);
          if (this.vNames[name].type === 'text'
            || this.vNames[name].type === 'textarea') {
            value = el.value;
            result = el.value;
          } else if (this.vNames[name].type === 'radio'
            || this.vNames[name].type === 'checkbox') {
            value = [];
            result = '';
            const btns = el.querySelectorAll(`input[type=${this.vNames[name].type}]`);
            btns.forEach((btn, i) => {
              if (btn.checked) {
                value.push(i);
                if (result) result += ', ';
                result += btn.value;
              }
            });
          } else if (this.vNames[name].type === 'select') {
            value = el.selectedIndex;
            result = el.value;
          }

          // 入力内容を保持
          this.formResult[name] = result; //確認画面 表示用
          this.formValue[name] = value;

          // 入力チェック エラーの場合はisError=true
          this.validate(this.vNames[name], name, value);

          if (this.isError) {
            // 入力エラーあり
            this.onFails();
          } else {
            // 入力エラーなし
            this.onPasses();
          }
        }
      },
      // バリデーションError
      onFails() {
        this.isConfirm = false;
        this.isValidated = false;

        document.getElementById('err-lead').style.display = 'block';

        for (let name in this.errMsgs) {
          if (typeof(name) !== 'string') continue;
          document.getElementById(`err-${name}`).textContent = this.errMsgs[name];
          document.getElementById(`err-${name}`).style.display = 'block';
        }

        this.pageTop();
      },
      // バリデーションOK
      onPasses() {
        this.isConfirm = true;
        this.isValidated = true;

        // 確認画面にデータを表示する：本当のフォームにデータ入力する
        for (let name in this.vNames) {
          if (typeof(name) !== 'string') continue;

          const conf = document.getElementById(`conf-${name}`);
          if (conf) conf.textContent = xss(this.formResult[name]);
        }

        // スクロール
        this.pageTop();

        // フォームを消す
        gsap.set(document.getElementById('c-form'), {
          display: 'none',
        });

        // 確認画面を表示する
        gsap.set(document.getElementById('c-conf'), {
          display: 'block',
        });
      },
      back(e) {
        e.preventDefault();
        if (!this.isValidated) return;
        this.isConfirm = false;
        this.isValidated = false;
        this.hideErrors();

        // スクロール
        this.pageTop();

        // 確認画面を消す
        gsap.set(document.getElementById('c-conf'), {
          display: 'none',
        });

        // フォームを消す
        gsap.set(document.getElementById('c-form'), {
          display: 'block',
        });
      },
      submit(e) {
        e.preventDefault();
        if (this.isSend) return;
        this.isSend = true;

        //document.getElementById('wp-submit').click();
        this.ajax();
      },
      ajax() {
        const params = new URLSearchParams();
        params.append('state', 'complete');
        params.append('name', this.formValue['name']);
        params.append('mail1', this.formValue['mail1']);
        params.append('message', this.formValue['message']);

        axios.post('https://5m-goem.jp/php/contact/index.php', params).then(this.ajaxRes);

        //テスト用
        //this.ajaxRes();
      },
      ajaxRes(response) {
        // 送信完了
        console.log('ajaxRes', response);

        // スクロール
        this.pageTop();

        // 確認画面を消す
        gsap.set(document.getElementById('c-conf'), {
          display: 'none',
        });

        // 確認画面を消す
        gsap.set(document.getElementById('c-complete'), {
          display: 'block',
        });
      },
      validate(vNames, name, value) {
        if (!vNames.rule) return;

        for (let i in vNames.rule) {
          const rule = vNames.rule[i];

          if (rule === 'required') {
            if (validator.isEmpty(value, {ignore_whitespace: true})) {
              // 未入力
              this.isError = true;
              this.errMsgs[name] = `${vNames.name}を入力してください。`;
              break;
            }
          } else if (rule === 'required_arr') {
            if (value.length === 0) {
              this.isError = true;
              this.errMsgs[name] = `${vNames.name}を選択してください。`;
              break;
            }
          } else if (rule === 'required_select') {
            if (value === 0) {
              this.isError = true;
              this.errMsgs[name] = `${vNames.name}を選択してください。`;
              break;
            }
          }

          if (rule.indexOf('max:') > -1) {
            const max = rule.split(':');
            if (!validator.isLength(value, {min: 0, max: max[1]})) {
              // 文字数超え
              this.isError = true;
              this.errMsgs[name] = `${vNames.name}を${max[1]}文字以下で入力してください。`;
              break;
            }
          }

          if (rule === 'email') {
            if (!validator.isEmail(value)) {
              // メールアドレスが正しくない
              this.isError = true;
              this.errMsgs[name] = `メールアドレスが正しくありません`;
              break;
            }
          }

          if (rule.indexOf('equal:') > -1) {
            const equal = rule.split(':');
            const elEqual = document.getElementById(`usr-${equal[1]}`);
            if (!validator.equals(value, elEqual.value)) {
              this.isError = true;
              this.errMsgs[name] = `メールアドレスが一致していません`;
              break;
            }
          }
        }
      },
      hideErrors() {
        this.isError = false;
        this.errMsgs = {};

        document.getElementById('err-lead').style.display = 'none';

        for (let name in this.vNames) {
          if (typeof(name) !== 'string') continue;
          document.getElementById(`err-${name}`).textContent = '';
          document.getElementById(`err-${name}`).style.display = 'none';
        }
      },
      // 入力フォームの先頭へスクロール
      pageTop() {
        //console.log('フォームの先頭までスクロールする');
        const of = AnyStore.getOffset('#p-5m__contact');
        gsap.to(window, {duration: 0.6, scrollTo:{y: of.offset.top, autoKill: false}});
      }
    }
  }
</script>
